import urls from '../constants/urls';
import { gatherErrors } from '../utils/errorHandling';

export const PROCESSING_CSV = 'numbersImport/PROCESSING_CSV';
export const PROCESSING_CSV_SUCCESS = 'numbersImport/PROCESSING_CSV_SUCCESS';
export const PROCESSING_CSV_FAILED = 'numbersImport/PROCESSING_CSV_FAILED';

export const NUMBERS_IMPORTING_FAILED =
  'numbersImport/NUMBERS_IMPORTING_FAILED';
export const NUMBERS_IMPORTING_SUCCESS =
  'numbersImport/NUMBERS_IMPORTING_SUCCESS';
export const IMPORTING_NUMBERS = 'numbersImport/IMPORTING_NUMBERS';

const initialState = {
  processedCSV: null,

  failedProcessing: false,
  failedImporting: false,

  isProcessing: false,
  isImporting: false,

  message: null,

  processingErrors: [],
  importingErrors: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PROCESSING_CSV:
      return {
        ...state,
        failedProcessing: false,
        isProcessing: true,
        loadingMessage: 'Processing file',
      };

    case PROCESSING_CSV_SUCCESS:
      return {
        ...state,
        processedCsv: action.payload.data,
        isProcessing: false,
        failedProcessing: false,
        loadingMessage: null,
      };

    case PROCESSING_CSV_FAILED:
      return {
        ...state,
        failedProcessing: true,
        isProcessing: false,
        processingErrors: gatherErrors(action.error, 'process_csv_failed'),
        loadingMessage: null,
      };

    case IMPORTING_NUMBERS:
      return {
        ...state,
        failedImporting: false,
        isImporting: true,
        loadingMessage: 'Importing data. It can take a while',
      };

    case NUMBERS_IMPORTING_SUCCESS:
      return {
        ...state,
        isImporting: false,
        loadingMessage: null,
      };

    case NUMBERS_IMPORTING_FAILED:
      return {
        ...state,
        failedImporting: true,
        isImporting: false,
        loadingMessage: null,
      };

    default:
      return state;
  }
};

export const processCsv = (hospitalId, file) => dispatch => {
  return dispatch({
    types: [PROCESSING_CSV, PROCESSING_CSV_SUCCESS, PROCESSING_CSV_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.hospitals.numbersImport.validate(hospitalId),
        data: file,
      },
    },
  });
};

export const importNumbers = (hospitalId, file) => dispatch => {
  return dispatch({
    types: [
      IMPORTING_NUMBERS,
      NUMBERS_IMPORTING_SUCCESS,
      NUMBERS_IMPORTING_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.hospitals.numbersImport.create(hospitalId),
        data: { file: file },
      },
    },
  });
};
